'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _extends = require('../../node_modules/@babel/runtime/helpers/extends.js');
var objectWithoutProperties = require('../../node_modules/@babel/runtime/helpers/objectWithoutProperties.js');
var classCallCheck = require('../../node_modules/@babel/runtime/helpers/classCallCheck.js');
var createClass = require('../../node_modules/@babel/runtime/helpers/createClass.js');
var possibleConstructorReturn = require('../../node_modules/@babel/runtime/helpers/possibleConstructorReturn.js');
var getPrototypeOf = require('../../node_modules/@babel/runtime/helpers/getPrototypeOf.js');
var inherits = require('../../node_modules/@babel/runtime/helpers/inherits.js');
var React = require('react');
require('prop-types');
var AddressData = require('./AddressData.js');
var ObjectHelper = require('../../common/ObjectHelper.js');
var ListSubheader = require('../../node_modules/@material-ui/core/esm/ListSubheader/ListSubheader.js');
var MenuItem = require('../../node_modules/@material-ui/core/esm/MenuItem/MenuItem.js');
var Divider = require('../../node_modules/@material-ui/core/esm/Divider/Divider.js');
var TextField = require('../../node_modules/@material-ui/core/esm/TextField/TextField.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function billingAddressCountry(currentState) {
  if (ObjectHelper.isPresent(currentState)) {
    return AddressData.provinceOptions.map(function (x) {
      return x.value;
    }).includes(currentState) ? AddressData.OPTION_CANADA : AddressData.OPTION_USA;
  }

  return AddressData.OPTION_USA;
}

var StateSelectField =
/*#__PURE__*/
function (_PureComponent) {
  inherits(StateSelectField, _PureComponent);

  function StateSelectField() {
    classCallCheck(this, StateSelectField);

    return possibleConstructorReturn(this, getPrototypeOf(StateSelectField).apply(this, arguments));
  }

  createClass(StateSelectField, [{
    key: "addStateOptions",
    value: function addStateOptions(options) {
      options.push(React__default["default"].createElement(ListSubheader["default"], {
        key: 99998
      }, "States"));
      AddressData.stateOptions.map(function (state) {
        return options.push(React__default["default"].createElement(MenuItem["default"], {
          value: state.value,
          key: state.key
        }, state.value));
      });
    }
  }, {
    key: "addProvinceOptions",
    value: function addProvinceOptions(options) {
      options.push(React__default["default"].createElement(ListSubheader["default"], {
        key: 99997
      }, "Provinces"));
      AddressData.provinceOptions.map(function (state) {
        return options.push(React__default["default"].createElement(MenuItem["default"], {
          value: state.value,
          key: 1000 + state.key
        }, state.value));
      });
    }
  }, {
    key: "usMenuOptions",
    value: function usMenuOptions() {
      var options = [];
      this.addStateOptions(options);
      options.push(React__default["default"].createElement(Divider["default"], {
        key: 99999
      }));
      this.addProvinceOptions(options);
      return options;
    }
  }, {
    key: "canadaMenuOptions",
    value: function canadaMenuOptions() {
      var options = [];
      this.addProvinceOptions(options);
      options.push(React__default["default"].createElement(Divider["default"], {
        key: 99996
      }));
      this.addStateOptions(options);
      return options;
    }
  }, {
    key: "menuOptions",
    value: function menuOptions() {
      if (billingAddressCountry(this.props.value) === AddressData.OPTION_CANADA) {
        return this.canadaMenuOptions();
      } else {
        return this.usMenuOptions();
      }
    }
  }, {
    key: "stateLabel",
    value: function stateLabel() {
      return billingAddressCountry(this.props.value) === AddressData.OPTION_CANADA ? 'Province' : 'State';
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props;
          _this$props.children;
          _this$props.label;
          var restProps = objectWithoutProperties(_this$props, ["children", "label"]);

      return React__default["default"].createElement(TextField["default"], _extends["default"]({}, restProps, {
        select: true,
        label: this.stateLabel()
      }), this.menuOptions());
    }
  }]);

  return StateSelectField;
}(React.PureComponent);

exports.billingAddressCountry = billingAddressCountry;
exports["default"] = StateSelectField;
